import { PHONE_STATUS_LABELS } from '@claimup/shared/constants/phones';

/**
 * Tailwind color classes for phone status badges
 */
const PHONE_STATUS_COLORS = {
  active: 'bg-green-100 text-green-800',
  deleted: 'bg-red-100 text-red-800',
  blocked: 'bg-orange-100 text-orange-800',
};

/**
 * Get display label for phone status
 */
export const getPhoneStatusLabel = status => {
  return PHONE_STATUS_LABELS[status] || status;
};

/**
 * Get Tailwind color classes for phone status badge
 */
export const getPhoneStatusColors = status => {
  return PHONE_STATUS_COLORS[status] || 'bg-slate-100 text-slate-800';
};

/**
 * Get capacity status color classes
 */
export const getCapacityStatusColors = (current, max) => {
  if (max === null || max === undefined) {
    return 'text-slate-600';
  }
  const percentage = (current / max) * 100;
  if (percentage >= 100) {
    return 'text-red-600 font-semibold';
  }
  if (percentage >= 80) {
    return 'text-orange-600';
  }
  return 'text-green-600';
};

/**
 * Format capacity display
 */
export const formatCapacity = (current, max) => {
  if (max === null || max === undefined) {
    return 'Ilimitado';
  }
  return `${current}/${max}`;
};
